<header id="header" class="header fixed-top">
  <nav class="navbar navbar-expand-lg appendClass">
    <div class="container">
      <div class="for_destop d-sm-none d-lg-flex justify-content-between w-100">
        <a class="navbar-brand" href="#"
        ><img src="assets/images/Logo.png"
        /></a>

        <ul class="navbar-nav mb-2 mb-lg-0">
          <li>
            <a
              class="nav-link"
              [ngClass]="{ active: currentRoute === '' }"
              href="#"
            >Home</a
            >
          </li>
          <li>
            <a
              class="nav-link"
              [ngClass]="{ active: currentRoute === 'plans' }"
              routerLink="/plans"
            >Plans</a
            >
          </li>
          <li>
            <a
              class="nav-link"
              [ngClass]="{ active: currentRoute === 'support' }"
              routerLink="/support"
            >Support</a
            >
          </li>
          <li>
            <a
              class="nav-link"
              [ngClass]="{ active: currentRoute === 'artist' }"
              routerLink="/artist"
            >Are you a creator?</a
            >
          </li>
          <li>
            <a
              class="nav-link"
              [ngClass]="{ active: currentRoute === 'about-us' }"
              routerLink="/about-us"
            >About-us</a
            >
          </li>
          <ng-container *ngIf="!isLoggedIn">
            <li>
              <a class="nav-link br-left cursor-pointer" [ngClass]="{ active: currentRoute === 'sign-in' }" routerLink="/sign-in">
                User Login
              </a>
            </li>
          </ng-container>
          <ng-container *ngIf="isLoggedIn">
            <li>
              <a class="nav-link br-left cursor-pointer" (click)="buyToken()">Buy Token</a>
            </li>
            <li>
              <a class="nav-link cursor-pointer" (click)="logout()">Sign Out</a>
            </li>
          </ng-container>
        </ul>
      </div>
      <div class="for_mobile w-100 d-lg-none d-sm-block">
        <div class="mobile_logo_view d-flex justify-content-between">
          <a class="navbar-brand for_mobile" href="#"
          ><img src="assets/images/Logo.png"
          /></a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"
            ><img src="assets/images/menu.png "
            /></span>
          </button>
        </div>
        <div
          class="collapse navbar-collapse flexgrow"
          id="navbarSupportedContent"
        >
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li>
              <a
                class="nav-link active"
                [ngClass]="{ active: currentRoute === '' }"
                href="#"
              >
                <div class="svg_icon">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.98202 20.3161H16.018C18.3927 20.3161 20.3167 18.3835 20.3167 16.0175V9.70812C20.3167 8.45146 19.5107 6.90879 18.4794 6.18946L13.1234 2.43679C11.6674 1.41412 9.42268 1.46612 8.01868 2.55812L3.34735 6.19812C2.41135 6.92612 1.68335 8.40812 1.68335 9.58679V16.0088C1.68335 18.3835 3.60735 20.3161 5.98202 20.3161ZM4.14468 7.22079L8.81602 3.58079C9.76068 2.84412 11.39 2.80946 12.378 3.50279L17.734 7.25546C18.4187 7.72346 19.0167 8.87612 19.0167 9.70812V16.0175C19.0167 17.6728 17.6734 19.0161 16.018 19.0161H5.98202C4.32668 19.0161 2.98335 17.6641 2.98335 16.0088V9.58679C2.98335 8.80679 3.52935 7.70612 4.14468 7.22079ZM10.35 16.1992C10.35 16.5546 10.6447 16.8492 11 16.8492C11.3554 16.8492 11.65 16.5546 11.65 16.1992V13.5992C11.65 13.2439 11.3554 12.9492 11 12.9492C10.6447 12.9492 10.35 13.2439 10.35 13.5992V16.1992Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <span>Home</span>
              </a>
            </li>
            <li>
              <a
                class="nav-link"
                [ngClass]="{ active: currentRoute === 'plans' }"
                routerLink="/plans"
              >
                <div class="svg_icon">
                  <svg
                    width="20"
                    height="18"
                    viewBox="0 0 20 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.9917 1.67094C2.35626 1.61887 1.87683 2.07131 1.87683 2.65969V13.0984C1.87683 13.5529 2.28517 14.0223 2.77023 14.0815L2.77947 14.0826L2.77946 14.0826L3.03337 14.1168L3.03486 14.117C4.82931 14.3511 7.45261 15.1544 9.26144 15.9988V3.78061C9.22425 3.76263 9.18756 3.74291 9.15156 3.72136L8.93388 3.59403L8.92304 3.58757C7.44415 2.68826 4.73815 1.8088 2.99392 1.67111L2.9917 1.67094ZM16.9314 14.1168C15.1463 14.3483 12.5481 15.1451 10.7384 15.9885V3.78061C10.7775 3.76168 10.8161 3.74083 10.8539 3.71795L10.8656 3.71072L11.0099 3.61967C11.2754 3.45976 11.5824 3.29721 11.9199 3.1372V5.54594C11.9199 5.81514 12.0684 6.0627 12.3068 6.19085C12.5452 6.319 12.8352 6.30714 13.0621 6.15995L14.4307 5.27248L15.7992 6.15995C16.0262 6.30714 16.3161 6.319 16.5545 6.19085C16.7929 6.0627 16.9414 5.81514 16.9414 5.54594V1.68206C16.9607 1.68199 16.98 1.68116 16.9992 1.67959C17.6418 1.62693 18.123 2.07831 18.123 2.66834V13.0984C18.123 13.5525 17.7153 14.0216 17.2307 14.0813L17.2296 14.0815L16.9397 14.1157L16.9397 14.1157L16.9314 14.1168ZM3.11206 0.209148C1.63894 0.0890359 0.399902 1.19182 0.399902 2.65969V13.0984C0.399902 14.3013 1.37122 15.3859 2.58521 15.5366L2.83809 15.5706L2.8412 15.571C4.67546 15.8101 7.5582 16.7331 9.18084 17.5985C9.189 17.6028 9.19724 17.607 9.20556 17.6111L9.22918 17.6225C9.47787 17.7527 9.7543 17.8002 9.99436 17.8002C10.2362 17.8002 10.5201 17.752 10.773 17.6118C12.3944 16.7401 15.2782 15.8112 17.1187 15.5716L17.4069 15.5375L17.4095 15.5372C18.6259 15.3889 19.5999 14.303 19.5999 13.0984V2.66834C19.5999 1.19552 18.3628 0.113927 16.9105 0.215404H16.8853C16.8652 0.215404 16.8451 0.216219 16.8251 0.217847C16.5984 0.23627 16.3456 0.26442 16.0788 0.312249C14.9307 0.49504 13.5892 0.872883 12.3902 1.33698L12.387 1.3382C11.5895 1.65109 10.8405 2.00558 10.2366 2.37008L10.2242 2.37775L10.0895 2.46274C10.0868 2.4637 10.0821 2.46522 10.0751 2.46692C10.0562 2.47151 10.03 2.47508 9.9999 2.47508C9.96978 2.47508 9.94363 2.47151 9.92474 2.46692C9.91644 2.4649 9.91131 2.46313 9.90899 2.46226L9.90501 2.45989L9.68877 2.33341C8.01236 1.31581 5.08748 0.365356 3.11206 0.209148ZM13.3968 4.19122V2.52909C14.0826 2.28534 14.7957 2.07722 15.4645 1.92558V4.19122L14.8344 3.78263C14.5891 3.62353 14.2723 3.62353 14.0269 3.78263L13.3968 4.19122Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <span>Plans</span>
              </a>
            </li>
            <li>
              <a
                class="nav-link"
                [ngClass]="{ active: currentRoute === 'support' }"
                routerLink="/support"
              >
                <div class="svg_icon">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.0848 3.08304C2.40823 3.75759 1.9999 4.83395 1.9999 6.46485V10.8519C1.9999 12.9759 2.43292 13.9917 3.04588 14.5264C3.68602 15.0849 4.73394 15.3164 6.48016 15.3164H6.92018C7.19617 15.3164 7.4595 15.4017 7.66296 15.5023C7.86341 15.6013 8.09649 15.76 8.26619 15.99L9.58359 17.7412C9.7447 17.9554 9.90313 18.0012 10.0003 18.0012C10.0975 18.0012 10.256 17.9554 10.4171 17.7412L11.7371 15.9864L11.7402 15.9823C12.0568 15.567 12.5548 15.3164 13.0805 15.3164H13.5205C15.1579 15.3164 16.2388 14.9087 16.9159 14.2337C17.5924 13.5592 18.0008 12.4828 18.0008 10.8519V6.46485C18.0008 4.83395 17.5924 3.75759 16.9159 3.08304C16.2388 2.40805 15.1579 2.00039 13.5205 2.00039H6.48016C4.84279 2.00039 3.76182 2.40805 3.0848 3.08304ZM1.95513 1.94997C3.0382 0.870144 4.59736 0.400391 6.48016 0.400391H13.5205C15.4033 0.400391 16.9625 0.870144 18.0455 1.94997C19.129 3.03024 19.6008 4.58611 19.6008 6.46485V10.8519C19.6008 12.7306 19.129 14.2865 18.0455 15.3668C16.9625 16.4466 15.4033 16.9164 13.5205 16.9164H13.0805C13.0608 16.9164 13.0313 16.9286 13.0134 16.9514L13.0127 16.9523L11.6957 18.7031C11.276 19.261 10.6688 19.6012 10.0003 19.6012C9.33189 19.6012 8.72469 19.261 8.30497 18.7031L6.99387 16.9602C6.98543 16.9541 6.97186 16.9455 6.95403 16.9366C6.93333 16.9264 6.91482 16.9198 6.90248 16.9165L6.48016 16.9164C4.70621 16.9164 3.114 16.7091 1.99406 15.7321C0.846929 14.7314 0.399902 13.115 0.399902 10.8519V6.46485C0.399902 4.58611 0.87162 3.03024 1.95513 1.94997ZM7.5999 6.79402C7.5999 5.46903 8.66841 4.40039 9.99348 4.40039C11.3185 4.40039 12.3871 5.46903 12.3871 6.79402C12.3871 7.84666 11.6925 8.40098 11.2529 8.7014C11.0679 8.82921 10.9566 8.92458 10.8868 9.0182C10.8317 9.09215 10.7935 9.17599 10.7935 9.31883V9.52039C10.7935 9.96222 10.4353 10.3204 9.99348 10.3204C9.55165 10.3204 9.19348 9.96222 9.19348 9.52039V9.31883C9.19348 8.2427 9.9046 7.68802 10.3454 7.38369L10.3487 7.38136L10.3487 7.38137C10.5244 7.26141 10.6317 7.16836 10.6983 7.07857C10.7513 7.00698 10.7871 6.92707 10.7871 6.79402C10.7871 6.35261 10.4348 6.00039 9.99348 6.00039C9.55214 6.00039 9.1999 6.35261 9.1999 6.79402C9.1999 7.23585 8.84173 7.59402 8.3999 7.59402C7.95807 7.59402 7.5999 7.23585 7.5999 6.79402ZM9.98916 11.0152C9.54733 11.0152 9.18916 11.3734 9.18916 11.8152C9.18916 12.2571 9.54733 12.6152 9.98916 12.6152H9.9978C10.4396 12.6152 10.7978 12.2571 10.7978 11.8152C10.7978 11.3734 10.4396 11.0152 9.9978 11.0152H9.98916Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <span>Support</span>
              </a>
            </li>
            <li>
              <a
                class="nav-link"
                [ngClass]="{ active: currentRoute === 'artist' }"
                routerLink="/artist"
              >
                <div class="svg_icon">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.3545 0.478871C10.5185 0.5571 10.6509 0.688573 10.7302 0.851741L13.0827 5.69592C13.1763 5.88874 13.3436 6.03603 13.547 6.10478L19.0551 7.96665C19.4746 8.10842 19.6994 8.56258 19.5573 8.98105C19.5103 9.11949 19.4261 9.24244 19.314 9.33654L15.9753 12.1387C15.7682 12.3125 15.6629 12.5788 15.6954 12.8469L16.4049 18.7016C16.4581 19.1402 16.1448 19.5388 15.7052 19.5918C15.5612 19.6092 15.4153 19.5873 15.2828 19.5285L10.3297 17.3286C10.1223 17.2365 9.88542 17.2364 9.67794 17.3284L4.72143 19.5262C4.31676 19.7056 3.8429 19.5238 3.66305 19.12C3.60367 18.9867 3.58195 18.8398 3.60025 18.695L4.33894 12.8519C4.37317 12.5811 4.26669 12.3116 4.05648 12.137L0.688685 9.33919C0.34837 9.05648 0.302201 8.55205 0.585563 8.21251C0.680637 8.09859 0.805569 8.01326 0.946417 7.96606L6.49872 6.10511C6.70432 6.0362 6.87316 5.88714 6.96674 5.69193L9.2852 0.855409C9.47627 0.456822 9.95502 0.288239 10.3545 0.478871ZM9.90491 3.26966L8.41346 6.38226C8.15613 6.9191 7.70905 7.3396 7.16124 7.56519L7.00941 7.62182L3.02206 8.95791C2.95909 8.97901 2.92519 9.04705 2.94634 9.10987C2.95344 9.13096 2.96627 9.14966 2.98341 9.16389L5.08263 10.9074C5.67121 11.3964 5.98872 12.1332 5.94495 12.8897L5.93001 13.0521L5.39593 17.2761C5.38762 17.3419 5.4343 17.4019 5.50021 17.4102C5.52196 17.4129 5.54405 17.4097 5.56408 17.4008L9.02665 15.8663C9.59721 15.6133 10.2418 15.5924 10.8246 15.8035L10.9819 15.8669L14.4487 17.4067C14.5094 17.4337 14.5805 17.4064 14.6075 17.3459C14.6164 17.3261 14.6197 17.3042 14.617 17.2827L14.1033 13.039C14.0124 12.2884 14.2813 11.5423 14.8228 11.0222L14.9429 10.9143L17.029 9.16271C17.0798 9.12004 17.0863 9.04434 17.0435 8.99363C17.0294 8.97686 17.0109 8.96427 16.9901 8.95724L13.0324 7.62017C12.4731 7.4311 12.0048 7.04406 11.7143 6.5353L11.6395 6.39359L10.1217 3.26908C10.0927 3.20945 10.0207 3.18453 9.96096 3.21344C9.93643 3.2253 9.91667 3.24513 9.90491 3.26966Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <span>Are you a creator?</span>
              </a>
            </li>
            <li>
              <a
                class="nav-link"
                [ngClass]="{ active: currentRoute === 'about-us' }"
                routerLink="/about-us"
              >About-us</a
              >
            </li>
            <ng-container *ngIf="!isLoggedIn">
              <li>
                <a
                  class="nav-link"
                  routerLink="/sign-in"
                >
                  <div class="svg_icon">
                    <svg
                      width="14"
                      height="20"
                      viewBox="0 0 14 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.04771 5.17265C4.04771 3.36768 5.39411 2.00039 6.95132 2.00039C8.50088 2.00039 9.85417 3.36812 9.85494 5.17111C9.84738 6.92383 8.58589 8.25516 7.10141 8.33444C7.00012 8.32731 6.89489 8.32769 6.79467 8.33454C5.3087 8.2562 4.04771 6.92402 4.04771 5.17265ZM6.95132 0.400391C4.40452 0.400391 2.44771 2.59382 2.44771 5.17265C2.44771 7.69848 4.315 9.84654 6.78069 9.93544C6.81621 9.93672 6.85178 9.93563 6.88715 9.93218C6.92998 9.928 6.97523 9.92879 6.99947 9.93139C7.03737 9.93546 7.07551 9.93681 7.11361 9.93544C9.57962 9.84653 11.4451 7.69873 11.4549 5.17575L11.4549 5.17265C11.4549 2.59261 9.48865 0.400391 6.95132 0.400391ZM11.7291 11.7864C10.4243 10.852 8.74062 10.4093 7.09524 10.4093C5.44934 10.4093 3.76245 10.8523 2.45045 11.7853L2.4475 11.7874C1.26843 12.6339 0.600098 13.8119 0.600098 15.0664C0.600098 16.321 1.26854 17.4971 2.44842 18.3394C3.75689 19.278 5.44262 19.7235 7.08899 19.7235C8.73567 19.7235 10.4217 19.2779 11.7303 18.3388C12.9094 17.4923 13.5779 16.3142 13.5779 15.0597C13.5779 13.8049 12.9092 12.6287 11.7291 11.7864ZM2.2001 15.0664C2.2001 14.4179 2.54069 13.6907 3.37918 13.0881L10.7973 17.039C9.812 17.746 8.47019 18.1235 7.08899 18.1235C5.70771 18.1235 4.36583 17.746 3.3805 17.0389L3.37875 17.0376C2.5406 16.4396 2.2001 15.7149 2.2001 15.0664ZM3.37918 13.0881L10.7973 17.039C11.6368 16.4362 11.9779 15.7085 11.9779 15.0597C11.9779 14.4112 11.6374 13.6865 10.7992 13.0884L10.798 13.0876C9.8173 12.3851 8.47752 12.0093 7.09524 12.0093C5.71387 12.0093 4.36928 12.3846 3.37918 13.0881Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <span>User Login</span>
                </a>
              </li>
            </ng-container>
            <ng-container *ngIf="isLoggedIn">
              <li>
                <a class="nav-link cursor-pointer" (click)="buyToken()">
                  <span>Buy Token</span>
                </a>
              </li>
              <li>
                <a class="nav-link cursor-pointer" (click)="logout()">
                  <span>Sign Out</span>
                </a>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</header>
